export default "__VITE_ASSET__arkdpwPP__"